$(function(){
    let $BlockNotification = $('.BlockNotification');

    if ( $BlockNotification.length )
    {
        let $BlockNotificationHeight = $BlockNotification.height();

        $(window).on('load scroll', function(){
            if ( $(window).scrollTop() > (2 * $BlockNotificationHeight) )
            {
                if ( $BlockNotification.is(':visible') )
                {
                    $BlockNotificationHeight = 0;
                    $BlockNotification.slideUp(300);
                    $BlockNotification.removeClass("NotificationShown");
                }
            }
            else
            {
                $BlockNotification.slideDown(300, function(){
                    $BlockNotificationHeight = $BlockNotification.height();
                    $BlockNotification.addClass("NotificationShown");
                });
            }
        });
    }
});